import cookies from 'js-cookie';

/**
 * sets data in cookies
 * @param {string} name
 * @param {string} item [data that needs to be saved]
 */
export function setItem(name,item){
  // return window.localStorage.setItem(name, item);
  return cookies.set(name, item, { expires: 30 });
}

/**
 * gets data in cookies
 * @param {string} name [name of cookie]
 * @return {string} [cookie data]
 */
export function getItem(name){
  return cookies.get(name);
}
/**
 * removes cookie
 * @param {string} name [name of cookie]
 */
export function removeItem(name){
  // window.localStorage.removeItem(name);
  cookies.remove(name);
}


/* Localstorage to store data */
export function setStorageItem(name, item) {
  localStorage.setItem(name, item);
}

export function getStorageItem(name) {
  const data = localStorage.getItem(name);
  return data === "undefined" ? null : data;
}

export function removeStorageItem(name) {
  localStorage.removeItem(name);
}


// WEBPACK FOOTER //
// ./src/utils/storage.js